import {SuiModalService} from '@angular-ex/semantic-ui';
import {Component, OnInit} from '@angular/core';

import {Topic} from '../../../../core/models/topics/topics.model';
import {TopicsService} from '../../../../core/services/topics/topics.service';

@Component({
  selector: 'app-manage-subjectareas',
  templateUrl: './manage-subjectareas.component.html',
  styleUrls: ['./manage-subjectareas.component.css'],
  standalone: false,
})
export class ManageSubjectareasComponent implements OnInit {
  public subjectAreas: Topic[] = [];

  constructor(
    private topicsService: TopicsService,
    public modalService: SuiModalService,
  ) {
  }

  ngOnInit() {
    this.topicsService.getAll({
      isSubjectArea: true,
      select: ['name', 'englishName', 'description', 'englishDescription'],
    }).subscribe(res => {
      this.subjectAreas = res.docs;
    });
  }
}
